import React, { Fragment } from "react";
import { Event, CategoryTag, Locale } from "../../core/api/model";
import { DashboardFavouritesEventsListItem, DashboardFavouritesListEmpty } from ".";

export interface DashboardFavouritesEventsListProps {
  locale: Locale;
  events: Event[];
  deleteFavourite: (elementId: number, categoryTag: CategoryTag) => void;
}

export const DashboardFavouritesEventsList = (props: DashboardFavouritesEventsListProps) => {
  return props.events.length > 0 ? (
    // list
    <Fragment>
      {props.events.map((event: Event) => 
        <DashboardFavouritesEventsListItem key={event.eventId}
                                          locale={props.locale}
                                          event={event}
                                          deleteFavourite={props.deleteFavourite}
        />
      )}
    </Fragment>
  ) :
  // empty
  <DashboardFavouritesListEmpty />
};
